import React, { SVGAttributes } from 'react'

const ArrowWithStick: React.FC<SVGAttributes<SVGSVGElement>> = (props) => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="#0F1011" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.75 10.9997C2.75 10.4934 3.16041 10.083 3.66667 10.083H18.3333C18.8396 10.083 19.25 10.4934 19.25 10.9997C19.25 11.5059 18.8396 11.9163 18.3333 11.9163H3.66667C3.16041 11.9163 2.75 11.5059 2.75 10.9997Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.81485 4.85149C10.1728 5.20947 10.1728 5.78988 9.81485 6.14786L4.96303 10.9997L9.81485 15.8515C10.1728 16.2095 10.1728 16.7899 9.81485 17.1479C9.45687 17.5058 8.87647 17.5058 8.51849 17.1479L3.01849 11.6479C2.6605 11.2899 2.6605 10.7095 3.01849 10.3515L8.51849 4.85149C8.87647 4.49351 9.45687 4.49351 9.81485 4.85149Z"
    />
  </svg>

)

export default ArrowWithStick
